import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {ItemManagerService} from "../../../../services/itemManager/item-manager.service";
import {ParticipantPlugin} from "../ParticipantPlugin";
import {group} from "@angular/animations";
import {Item} from "../../../../models/Item";

@Injectable({
  providedIn: 'root'
})
export class ParticipantsService {

  private _currentParticipant: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private _participantList: BehaviorSubject<[]> = new BehaviorSubject<[]>([]);

  constructor(private itemManagerService: ItemManagerService) {
    this._participantList.next((window['EVENT_CONFIG'].hasOwnProperty('participant_groups') ? window['EVENT_CONFIG']['participant_groups'] : []));
  }

  get participantList(): Observable<[]>{
    return this._participantList.asObservable();
  }

  get currentParticipant(): Observable<string|number> {
    return this._currentParticipant.asObservable();
  }

  getParticipantGroupsFromItem(item:Item):string[]{
    let input = item.config.getInputByName(Item.ParticipantName);
    if (input && input.value.trim().length > 0) {
      return input.value.split('|||').filter(function (v) {
        return v.length;
      });
    }
    return [];
  }

  getItemVisibilityByCurrentParticipantGroup(item){
    let val = this._currentParticipant.getValue();
    if (val) {
      let input = item.config.getInputByName(Item.ParticipantName);
      if (input){
        if (input.value.toString().trim().length == 0){
          return true;
        }
        let values = this.getParticipantGroupsFromItem(item);
        if (values.includes(val) || values.length == 0){
          return true;
        }
      }
      return false;
    } else {
      return true;
    }
  }

  updateItemParticipantValue(item, groups:string[]){
    let data = this.prepareParticipantGroupsVal(groups);
    item.config.setInputValue(Item.ParticipantName, 'value', data);
  }

  setCurrentParticipant(val: string) {
      this._currentParticipant.next(val);
  }

  private prepareParticipantGroupsVal(groups){
    return groups.join('|||');
  }
}
